import { Button, ButtonBase, Dialog, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState, useRef, useEffect, useContext } from 'react';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import CloseIcon from '@mui/icons-material/Close';
import { Container } from 'react-bootstrap';
import ApiFetch from '../ApiFetch';
import { planDialog } from '../../service/CommonUtil';
import { t } from 'i18next';
import CommonDialog from '../common/CommonDialog';
import Constants from '../common/Constants';
import DiamondIcon from '@mui/icons-material/Diamond';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import Fade from '@mui/material/Fade';
import { LoginInfo } from '../../App';

function PaymentMethodSelector(props) {
  async function getPostInfo(type){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/postInfo").then((r)=>r.json().then((json)=>{
        return json
    }))
  }
  // ログイン情報
  const {loginInfo,setLoginInfo} = useContext(LoginInfo)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [paymentMethod, setPaymentMethod] = useState(props.value || "stripe")
  const[postInfo,setPostInfo] = useState([])
  const[postCount,setPostCount] = useState(0)
  const[limitCount,setLimitCount] = useState(0)

  // 親コンポーネントからのvalue変更を反映
  useEffect(() => {
    if (props.value !== undefined) {
      setPaymentMethod(props.value);
    }
  }, [props.value]);
  // ダイアログ
  const [show, setShow] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [okButtonShow,setOkButtonShow] = useState(false)
  function dialog(title,message){
      setDialogTitle(title)
      setDialogMessage(message)
      setShow(true)
  }

  return (
    <div className='d-inline'>
        <Button
            variant='outlined'
            id="fade-button"
            aria-controls={open ? 'fade-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(e) => setAnchorEl(e.currentTarget)}
        >
            {paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} /> {props.pointCost.toLocaleString()}</> : paymentMethod === "coin" ? <>{Constants.CURRENCY_UNIT_LEFT_COIN} {props.coinCost.toLocaleString()}</> : paymentMethod === "ticket" ? <><ConfirmationNumberIcon style={{color:"green"}} /> チケット ({props.availableTicketCount !== undefined ? props.availableTicketCount : 0}枚)</> : <><Icon.CreditCard /> Stripe</>}
        </Button>
        <Menu
            id="fade-menu"
            MenuListProps={{
            'aria-labelledby': 'fade-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            TransitionComponent={Fade}
        >
            <MenuItem onClick={() => {
                setAnchorEl(null)
                setPaymentMethod("point")
                props.onChange("point")
                }}><DiamondIcon style={{color:"blue"}} /> ポイント</MenuItem>
            <MenuItem onClick={() => {
                setAnchorEl(null)
                setPaymentMethod("coin")
                props.onChange("coin")
            }} >{Constants.CURRENCY_UNIT_LEFT_COIN} コイン{loginInfo.sms_auth === 1 && loginInfo.age18 && (loginInfo.r18_display_flag === 1) && props.modelType !== "Mid" && props.modelType !== "SD3" && props.modelType !== "DALL-E3" && props.modelType !== "FLUX.1" ? "" : ""}</MenuItem>
            <MenuItem onClick={() => {
                setAnchorEl(null)
                setPaymentMethod("ticket")
                props.onChange("ticket")
            }} ><ConfirmationNumberIcon style={{color:"green"}} /> 生成チケット</MenuItem>
            {props.hideStripe !== true && (
                <MenuItem onClick={() => {
                    setAnchorEl(null)
                    setPaymentMethod("stripe")
                    props.onChange("stripe")
                }} ><Icon.CreditCard /> クレジットカード</MenuItem>
            )}
        </Menu>
    </div>
  );
}

export default PaymentMethodSelector;
